import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormInstance } from '../../models/site-content/form-instance.model';
import { FormInstanceService } from '../../services/form-instance.service';
import { Workflow } from '../../models/site-content/workflow.model';
import { WorkflowTransition } from '../../models/workflow-transition.model';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../dialogs/confirmation/confirmation-dialog.component';
import { IDrawerComponentLiaison } from '../../interfaces/idrawer-component-liaison';
import { DrawerComponentBase } from '../drawer-component-base/drawer-component-base.component';

@Component({
    selector: 'app-form-instance-details',
    templateUrl: './form-instance-details.component.html',
    styleUrls: ['./form-instance-details.component.scss', '../properties.scss'],
    standalone: false
})
export class FormInstanceDetailsComponent extends DrawerComponentBase implements OnInit {
    // Properties.
    // Inputs.
    @Input() formInstance: FormInstance;
    @Input() drawerComponentLiaison: IDrawerComponentLiaison = null;

    // Outputs.
    @Output() save: EventEmitter<FormInstance> = new EventEmitter();
    @Output() transition: EventEmitter<FormInstance> = new EventEmitter();
    @Output() delete: EventEmitter<FormInstance> = new EventEmitter();
    @Output() close: EventEmitter<FormInstance> = new EventEmitter();

    // Reactive Forms properties.
    private ngFormGroup: UntypedFormGroup; // naming it this to avoid confusion with Collect's Forms vs NG's Forms

    private availableWorkflowTransitions: WorkflowTransition[] = null;
    public workflowName: string = null;

    // constructor.
    public constructor(private fb: UntypedFormBuilder, private formInstanceService: FormInstanceService, public dialog: MatDialog) {
        super();
    }

    // Life cycle methods.
    public ngOnInit(): void {
        super.ngOnInit(); // Important to call this as the first line in this method.

        this.ngFormGroup = this.fb.group({
            name: [this.formInstance.name, Validators.required],
            id: [this.formInstance.id],
            formId: [this.formInstance.formId],
            folderId: [this.formInstance.folderId],
            //TEAMS-424: KLW - Reference workflowId
            workflowId: [this.formInstance.workflowId]
        });
        this.workflowName = this.SiteWorkflows.find(wf => wf.id == this.formInstance.workflowId).name;
        this.availableWorkflowTransitions = this.formInstance.workflowStateTransitions;
    }

    // Accessor methods called by my HTML code.
    public get NgFormGroup(): UntypedFormGroup {
        return (this.ngFormGroup);
    }

    public get SiteWorkflows(): Workflow[] {
        return (this.formInstance.siteWorkflows != null ? this.formInstance.siteWorkflows : []);
    }

    public get ShowWorkflowStateControl(): boolean {
        let bShow: boolean =
            (this.formInstance.canTransition && this.formInstance.workflowStateTransitions && this.formInstance.workflowStateTransitions.length > 0);

        return (bShow);
    }

    public get WorkflowStateTransitions(): WorkflowTransition[] {
        //return (this.formInstance.workflowStateTransitions);
        return (this.availableWorkflowTransitions);
    }

    // Handle control events.
    public onSave(): void {
        // 10-24-2022 note:  need to discuss the following line, now
        //                   commented out, with other developers.
        //this.formInstance = this.ngFormGroup.value;
        this.formInstance.name = this.ngFormGroup.controls['name'].value;
        // 10-24-2022 note:  do other field values need to get set in this method as well?
        this.save.emit(this.formInstance);
    }

    public onDelete(): void {
        this.delete.emit(this.formInstance);
    }

    public onClose(): void {
        this.close.emit();
    }

    public reset(): void {
        if (!this.ngFormGroup.dirty) {
            this.onClose();
        }
        this.ngFormGroup.reset(this.formInstance);
    }

    public workflowSelectionChanged(workflowId: number): void {
        let workflow: Workflow = this.SiteWorkflows.find(wf => wf.id == workflowId);

        if (workflow != null) {
            this.availableWorkflowTransitions = workflow.transitions;
        }        
    }

    public transitionWorkflow(evt: WorkflowTransition): void {
        console.log({ transitionWorkflow: evt });
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmationDialogModel(
                `Change Workflow State`,
                `Are you sure you want to apply the "${evt.name}" transition?`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                this.formInstance.selectedWorkflowTransition = evt.name;
                this.transition.emit(this.formInstance);
            }
        });
    }
}
